import { AppInfoModule } from '@addins/app-info';
import { AppReloadModule } from '@addins/app-reload';
import { CoreAddinModule } from '@addins/core';
import { ALERT_PROVIDER_TOKEN } from '@addins/core/core';
import { FollowupStampsToolsModule } from '@addins/core/followup-stamps-tools';
import { SiteSelectorService } from '@addins/core/login';
import { UnitActivityModule } from '@addins/core/unit-activity';
import { CreateEventModule, EventFactoryService } from '@addins/create-event';
import { DepartureTicketInfoModule } from '@addins/departure-ticket-info';
import { DeploymentModule } from '@addins/deployment';
import { DocumentsModule } from '@addins/documents';
import { DrawingModule } from '@addins/drawings';
import { EngagementModule } from '@addins/engagement';
import { ExternalItineraryModule } from '@addins/external-itinerary';
import { InAppItineraryModule } from '@addins/inapp-itinerary';
import { ListCallCardsModule } from '@addins/listcallcards';
import { MediaModule } from '@addins/media';
import { MediaMessageModule } from '@addins/media-messages';
import { OfflineMapModule } from '@addins/offline-map';
import { PlannedMissionsModule } from '@addins/planned-missions';
import { PnModule } from '@addins/pn/pn.module';
import { QuickResponseCodeModule } from '@addins/quick-response-code';
import { ResourceCountModule } from '@addins/resource-count';
import { SagaFormsModule } from '@addins/saga-forms';
import { SingleCallcardAttachmentsModule } from '@addins/singlecallcard-attachments';
import { SingleCallcardDestinationModule } from '@addins/singlecallcard-destination';
import { SingleCallcardJournalModule } from '@addins/singlecallcard-journal/src/module';
import { SinglecallcardParticularsModule } from '@addins/singlecallcard-particulars';
import { UnitCustomCreation } from '@addins/unit-custom-creation';
import { Vd144Module } from '@addins/vd144';
import { Provider } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CallCardDispatch } from '@models/imported/SagaSchema/CallCardDispatch';
import { CALLCARD_TYPE_INJECTION_TOKEN } from '@services/callcard/injector';
import { ModalService } from '@services/modal/modal.service';
import { RefreshTokenStorageService } from '@services/refresh-token-storage/refresh-token-storage.service';
import {
  CLAIMS_PROVIDER,
  DeviceTypes,
  HTTP_HEADER_INJECTION_TOKEN,
  IAuthParameters,
  IHttpHeaderConfig,
  IonicCoreModule,
  MODAL_SERVICE,
  SITE_SELECTOR
} from '@techwan/ionic-core';
import { LoginModule } from '@techwan/ionic-core/login';

const HEADERS: IHttpHeaderConfig = {
  deviceType: DeviceTypes.MobileWeb
};

const modalProvider = {
  provide: MODAL_SERVICE,
  useFactory: (modalService: ModalService) => modalService,
  deps: [ModalService]
};

const httpHeaderProvider = {
  provide: HTTP_HEADER_INJECTION_TOKEN,
  useFactory: (platform: Platform) => {
    HEADERS.platform = platform.platforms().join(',');
    return HEADERS;
  },
  deps: [Platform]
};

const siteSelectorProvider = {
  provide: SITE_SELECTOR,
  useFactory: (selector: SiteSelectorService) => selector,
  deps: [SiteSelectorService]
};

const authParameters: IAuthParameters = {
  deviceType: DeviceTypes.MobileWeb,
  doNotUseTokenCookie: true
};

const claimsProvider: Provider = {
  provide: CLAIMS_PROVIDER,
  useFactory: (claims: RefreshTokenStorageService) => claims,
  deps: [RefreshTokenStorageService]
};

export const ADDIN_MODULES = [
  LoginModule,
  CoreAddinModule,
  DocumentsModule,
  ListCallCardsModule,
  UnitActivityModule,
  PnModule,
  Vd144Module,
  EngagementModule,
  ResourceCountModule,
  PlannedMissionsModule,
  DepartureTicketInfoModule,
  SagaFormsModule,
  InAppItineraryModule,
  ExternalItineraryModule,
  OfflineMapModule,
  SingleCallcardDestinationModule,
  QuickResponseCodeModule,
  MediaModule,
  MediaMessageModule,
  DeploymentModule,
  DrawingModule,
  CreateEventModule,
  FollowupStampsToolsModule,
  SingleCallcardAttachmentsModule,
  SinglecallcardParticularsModule,
  SingleCallcardJournalModule,
  UnitCustomCreation,
  AppInfoModule,
  AppReloadModule,
  IonicCoreModule.forRoot({ authParameters, siteSelectorProvider, modalProvider, httpHeaderProvider, claimsProvider })
];

export const ADDIN_PROVIDERS = [
  ModalService,
  { provide: CALLCARD_TYPE_INJECTION_TOKEN, useValue: CallCardDispatch },
  { provide: ALERT_PROVIDER_TOKEN, useExisting: EventFactoryService }
];
